import { useEffect, useState } from "react";
import axiosInstance from "../utilities/axiosInstance";

function useFetch(url) {
  const [data, setData] = useState(null);
  useEffect(() => {
    axiosInstance.get(url).then((response) => {
      if (response.status === 200) {
        setData(response.data);
      } else {
        console.log(response);
      }
    });
  }, []);

  return data;
}

export default useFetch;
